<script>
    import { mapGetters } from 'vuex'
    import BaseDatatable from '@components/base-datatable'
    import { paylessMethods } from '@state/helpers'
    import CustomDatePickerRange from '@components/CustomDatePickerRange'
    import Multiselect from 'vue-multiselect'
    
    
    export default {
      name: 'LogsPaylessTable',
    
      components: { 
        BaseDatatable,
        CustomDatePickerRange ,
        Multiselect
      },
      data() {
        return {
          loadingReport: false,
          tableHeaders: [],
          filterset : null,
          filters: {
            'fecha__gte': null,
            'fecha__lte': null,
            'store': null,
            'casherRegister':null
          },
          filtersDate:{
            fecha__gte:null,
            fecha__lte:null,
          },
          filtersStore:null,
          filterCasherRegister:null
        }
      },
    
      beforeMount(){
        this.tableHeaders = [
            { key: 'barcode', label:'Código' },
            { key: 'order_id', label:'Número de Orden' },
            { key: 'status', label:'Estado' },
            { key: 'fecha', label: this.$t('date'),},
            { key: 'store', label: this.$t('CO') },
            { key: 'cashRegister', label: this.$t('cash_register') },
            { 
              key: 'value', 
              label: this.$t('value'),
              formatter: value => {
                  return this.$formatDollar(value)} },
        ]
      },
    
      watch: {
          filters: {
            deep: true,
            handler(filters) {
                let filters_list = []
                for (let filter in filters) {
                if (filters[filter]) {
                    filters_list.push(`${filter}=${filters[filter]}`)
                }
                }
                if (filters_list.length) {
                this.filterset = filters_list.join('&')
                }
                this.filter()
            },
          },
        },
        
      computed: {
        ...mapGetters({
          stores: 'captacionPos/stores',
          store: 'captacionPos/store',
          cashRegister: 'captacionPos/cashRegister',
        })
      },
    
      methods: {
        ...paylessMethods,
    
        myProvider(ctx) {
          let context = this
          ctx = context.$table_params(ctx)
          
          ctx += context.filterset ? `&${context.filterset}` : ''
          const promise = context.fetchLogsPayless(ctx)
          return promise
            .then((data) => {
              return data
            })
            .catch((error) => {
              context.$axios_error_noty(error, context)
              console.log(error)
              return []
            })
        },
    
        getReport() {
          let _ = this
          _.loadingReport = true
          
          let query = ''
          query += _.filterset ? `?${_.filterset}`: '?'
          query += `&CO=${_.store.store_code}`
          query += `&cash_register=${_.cashRegister.id}`
          const promise = _.fetchPaylessReport({
            query: query,
            type: { responseType: 'arraybuffer' },
          })
          return promise
            .then((response) => {
              const data = response.data
              const url = URL.createObjectURL(
                new Blob([data], {
                  type: 'application/pdf',
                })
              )
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', `Reporte Caja - Payless.pdf`)
              document.body.appendChild(link)
              link.click()
              _.loadingReport = false
            })
            .catch((error) => {
              _.loadingReport = false
                console.error(error)
              _.$axios_error_noty('Se presento un error en la descarga del archivo.', )
            })
        },
    
    
    
    
    
        setFilter(filter, value) {
          this.filters[filter] = value
        },
    
        filter() {
          this.$refs.table.lastFilter = ''
          this.$refs.table.onFiltered()
          setTimeout(() => this.$refs.table.refresh(), 200)
        },
    
        clear() {
          this.filters.fecha__gte = null
          this.filters.fecha__lte = null
          this.filters.store = null
          this.filters.casherRegister = null
          this.filtersDate={fecha__gte:null, fecha__lte:null}
          this.filterset = null
          this.filtersStore=null
          this.filterCasherRegister=null
          setTimeout(() => this.refresh(), 200)
        },
      },
    }
    </script>
    
    <template>
        <b-container fluid class="p-0">
          <b-row>
            <b-col>
              <b-card class="shadow">
                <b-row>
                  <b-col md="4" class="p-1">
                    <b-col>
                      <CustomDatePickerRange
                        label='Fecha'
                        v-model="filtersDate"
                        :value_start="filtersDate.fecha__gte"
                        :value_end="filtersDate.fecha__lte"
                        @input_start="
                          (value) => setFilter('fecha__gte', value+' 00:00:00')
                        "
                        @input_end="
                          (value) => setFilter('fecha__lte', value+' 23:59:59')
                        "
                    /></b-col>
                  </b-col>
                  <b-col md="4" class="p-1">
                    <b-form-group
                      label="CO"
                      >
                      <multiselect
                        v-model="filtersStore"
                        @input="(value) => setFilter('store', value.store_code)"
                        :options="stores"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :preserve-search="true"
                        placeholder="Centro Operativo"
                        label="store_name"
                        track-by="store_code"
                      >
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="p-1">
                    <b-form-group
                      label="Cajero"
                      >
                      <multiselect
                        v-model="filterCasherRegister"
                        @input="(value) => setFilter('casherRegister', value.codcaj)"
                        :options="store.casher_register"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :preserve-search="true"
                        placeholder="Cajero"
                        label="codcaj"
                        track-by="codcaj"
                      >
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col md="2" class="ml-auto pb-2">
                    <b-button
                      class="ml-1 rounded shadow-sm float-right"
                      variant="outline-primary"
                      @click="filter"
                      >
                      <i class="fas fa-filter"></i>
                    </b-button>
                    <b-button
                      class="rounded shadow-sm float-right"
                      variant="outline-primary"
                      @click="clear"
                      ><i class="fas fa-eraser"></i>
                    </b-button>
                  </b-col>
                </b-row>
    
                <BaseDatatable
                  ref="table"
                  :drfprovider="myProvider"
                  :tableheaders="tableHeaders"
                  :placeholderSearch="'Código o Número de Orden'"
                >
                  <template v-slot:buttons>
                    <b-button variant="outline-primary rounded-lg  mx-1"
                      @click="getReport">
                        <b-spinner v-if="loadingReport" label="Spinning" small></b-spinner>
                        <i v-else class="fas fa-download"></i>
                    </b-button>
                  </template>
                  <template v-slot:cell(status)="row">
                    Autorizada
                  </template>
                  <template v-slot:cell(fecha)="row">
                    {{row.item.fecha.replace("T", " ").slice(0, 16)}}
                  </template>
                </BaseDatatable>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
    
    </template>
    <style>
      .multiselect__single {
        max-width: 100%;
        text-wrap: nowrap;
        overflow-x: clip;
        font-size: 1rem!important; 
      }
    </style>